import { ListControl } from './list_control.js';

/**
 * List control to type friends or emails.
 */
class FriendListControl extends ListControl {
  static tagName = 'friend-list-control';
  constructor() {
    super();

    this.noValidate = true;
    this.breakOnSpace = true;
  }

  initialize() {
    super.initialize();

    this.placeholder = `email or friend's name`;
    this.editableListElement.classList.add('friends-list-control');
    this.autocompleteElement.getItemUI = item => {
      let title = item.title ? `title='${item.title}'` : '';
      let src = item.img || '';
      return `
        <div class='popup-list-item list-item-friend list-item-friend-block' ${title}>
          <img src='${src}' class='list-item-friend-avatar'>
          <div class='list-item-friend-info'>
            <span class='list-item-friend-name'>${item.name}</span><br>
            <span class='list-item-friend-email'>${item.email}</span>
          </div>
        </div>
      `;
    };
  }

  get valueAsArray() {
    return this.items.map(v => v.id || v.name);
  }

  get valueAsInvitees() {
    return this.valueAsArray.map(item => ({
      inviteeUserId: typeof item != 'string' ? item : undefined,
      inviteeEmail: typeof item == 'string' ? item : undefined,
      rights: ['read', 'write'],
      status: 'pending',
    }));
  }
}

FriendListControl.defineCustomElement();

export { FriendListControl };
